module.exports = __webpack_public_path__ + "img/69.5.COD.0519528d.png";